import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Chip,
    Icon,
    Stack,
    Typography,
    useTheme
} from "@mui/material";
import ReactJson from "react-json-view";

function JsonPanel({
    src,
    name = false,
    collapsed = 1,
    primary,
    secondary,
    defaultExpanded = false
}) {
    const {palette} = useTheme();
    const surface = palette.surface?.subtle || palette.background.default;
    const jsonTheme = {
        base00: surface,
        base01: surface,
        base02: palette.divider,
        base03: palette.text.secondary,
        base04: palette.text.secondary,
        base05: palette.text.primary,
        base06: palette.text.primary,
        base07: palette.text.primary,
        base08: palette.error.main,
        base09: palette.warning.main,
        base0A: palette.success.main,
        base0B: palette.success.main,
        base0C: palette.secondary.main,
        base0D: palette.info.main,
        base0E: palette.primary.main,
        base0F: palette.error.main
    };
    return (
        <Accordion
            variant="outlined"
            disableGutters
            defaultExpanded={defaultExpanded}
            sx={{
                borderRadius: "8px !important",
                "&:before": {display: "none"},
                maxWidth: "100%",
                overflow: "hidden"
            }}
        >
            <AccordionSummary
                expandIcon={<Icon>expand_more</Icon>}
                aria-controls="conteudo-json"
                sx={{px: 2, py: 0.5}}
            >
                <Stack
                    direction={{xs: "column", sm: "row"}}
                    spacing={1.5}
                    alignItems={{sm: "center"}}
                    width="100%"
                    pr={1}
                >
                    <Box flex={1}>
                        <Typography fontWeight={700}>
                            {primary || "Dados técnicos"}
                        </Typography>
                        {secondary && (
                            <Typography variant="body2" color="text.secondary">
                                {secondary}
                            </Typography>
                        )}
                    </Box>
                    <Chip
                        size="small"
                        variant="outlined"
                        icon={<Icon>data_object</Icon>}
                        label="JSON técnico"
                    />
                </Stack>
            </AccordionSummary>
            <AccordionDetails sx={{p: 0, borderTop: 1, borderColor: "divider"}}>
                <Box
                    p={2}
                    sx={{
                        maxWidth: "100%",
                        overflowX: "auto",
                        whiteSpace: "pre-wrap",
                        bgcolor: "surface.subtle"
                    }}
                >
                    <ReactJson
                        theme={jsonTheme}
                        src={src}
                        name={name}
                        collapsed={collapsed}
                        enableClipboard={false}
                        displayDataTypes={false}
                    />
                </Box>
            </AccordionDetails>
        </Accordion>
    );
}

export default JsonPanel;
